import { SearchCriteria } from "./search-criteria";
import { WeekDays } from "../enums/week-days";

export class GymClassDetailsSearchCriteria extends SearchCriteria {
  public GymClassId: number;
  public WeekDay: WeekDays;
  public ForAssignExercises: boolean;
}
